import { useScrmFetch } from "@/hooks/common/fetch/useFetch";
import hmacMd5 from 'crypto-js/hmac-md5';
import Hex from 'crypto-js/enc-hex';

export const useISCRMUploadApi = (referenceId) => {

  return async (obj) => {
    const { RUNTIME_ENV } = process.env;
    const keyMap = {
      LOCAL: 'B6B49EE3CEF84FC4BB369884100AD42A',
      DEV: 'B6B49EE3CEF84FC4BB369884100AD42A',
      SIT: 'B6B49EE3CEF84FC4BB369884100AD42A',
      UAT: 'B6B49EE3CEF84FC4BB369884100AD42A',
      PROD: '5681C1C4B332423184015BEB540211DF',
    }
    const timestamp = +new Date(), privateKey = keyMap[RUNTIME_ENV]; // ...
    const sign = Hex.stringify(hmacMd5(`timestamp${timestamp}`, privateKey));
    const formData = new FormData();
    formData.append("file", obj.file, obj.file.name);
    formData.append("timestamp", timestamp); 
    formData.append("sign", sign);
    formData.append("referenceId", referenceId);
  
    // TODO: 上传至OSS
    const { isFetching, error, data } = await useScrmFetch('/api/iscrm-redemption/giftRequestInfoApi/uploadFile').post(formData).json();
    // const { isFetching, error, data } = await useScrmFetch('/mbg/attachment/uploadFile').post(formData).json();
    console.log({ isFetching, error, data });
    return { file: obj.file, isFetching, error, data }
  }
}


export const useISCRMEdmUploadApi = () => {

  return async (obj) => {
    const { RUNTIME_ENV } = process.env;
    const keyMap = {
      LOCAL: 'B6B49EE3CEF84FC4BB369884100AD42A',
      DEV: 'B6B49EE3CEF84FC4BB369884100AD42A',
      SIT: 'B6B49EE3CEF84FC4BB369884100AD42A',
      UAT: 'B6B49EE3CEF84FC4BB369884100AD42A',
      PROD: '5681C1C4B332423184015BEB540211DF',
    }
    const timestamp = +new Date(), privateKey = keyMap[RUNTIME_ENV]; // ...
    const sign = Hex.stringify(hmacMd5(`timestamp${timestamp}`, privateKey));
    const formData = new FormData();
    formData.append("file", obj.file, obj.file.name);
    formData.append("timestamp", timestamp);
    formData.append("sign", sign);

    // TODO: 上传至OSS
    const { isFetching, error, data } = await useScrmFetch('/web/edm/mbg/attachment/uploadFile').post(formData).json();
    console.log({ isFetching, error, data });
    return { file: obj.file, isFetching, error, data }
  }
}

export const useISCRMUploadDelApi = async ({ attachmentId, referenceId, fileName}) => {
  // TODO: 上传至OSS
  const { isFetching, error, data } = await useScrmFetch(`/api/iscrm-redemption/giftRequestInfoApi/deleteFile?attachmentId=${attachmentId}&referenceId=${referenceId}&fileName=${fileName}`).get().json();
  return { isFetching, error, data }
} 